import { render, staticRenderFns } from "./businessRoleList.vue?vue&type=template&id=13efb81a&scoped=true&"
import script from "./businessRoleList.vue?vue&type=script&lang=js&"
export * from "./businessRoleList.vue?vue&type=script&lang=js&"
import style0 from "./businessRoleList.vue?vue&type=style&index=0&id=13efb81a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13efb81a",
  null
  
)

/* custom blocks */
import block0 from "./businessRoleList.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports